import React from 'react';

import { theme } from 'twin.macro';
import { StartOrEndMarker } from '../cards/StartOrEndMarker';

import { PageMode } from '$/components/ui/Input/PageBuilder.types';
import { useCardContext } from '../cards/CardContext';

const AnchorCard: React.FC = () => {
  const { interaction } = useCardContext();

  return (
    <StartOrEndMarker
      text={interaction.title()}
      color={theme`colors.black`.toString()}
      mode={PageMode.edit}
    />
  );
};

export default AnchorCard;
